export const FETCH_CITIES = 'fetchCities'
export const FETCHED_CITIES = 'fetchedCities'
export const SELECT_CITY = 'selectCity'
export const FETCH_CITY_MANAGER = 'fetchCityManager'
export const FETCHED_CITY_MANAGER = 'fetchedCityManager'
